module.exports = __webpack_public_path__ + "img/pouting_face.9b7f2998.gif";